//*
import React, { useState } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import WhatshotIcon from '@mui/icons-material/Whatshot';

import styles from './User.module.css';

export function Style() {

	return (
		<Box>
			<Card sx={{minWidth: 275, maxWidth: 1200}}>
				<CardContent>
					<Typography sx={{ fontSize: 14}} color="text.secondary" gutterBottom>
						test.secondary and gutterBottm
					</Typography>
					<Typography variant="h5" component="div">
						h5 component div
					</Typography>
					<Typography variant="body2">
						variant=body2
					</Typography>
				</CardContent>
				<CardActions>
					<Button size="small">Learn</Button>
				</CardActions>
			</Card>
			<Card>
				<CardContent>
					<Box sx={{color:'#7ba5ef', bgcolor:'#050f2d'}}>
						8, 15, 45 050f2d 
					</Box>
					<Box sx={{color:'#050f2d', bgcolor:'#7ba5ef'}}>
						123, 165, 239, 7ba5ef
					</Box>
					<Box sx={{color:'#050f2d', bgcolor:'#4f66c0'}}>
						79, 102, 192, 4f66c0
					</Box>
					<Box sx={{color:'#7ba5ef', bgcolor:'#1b2558'}}>
						27, 37, 88 1b2558
					</Box>
					<Box sx={{color:'#7ba5ef', bgcolor:'#26357b'}}>
						38, 53, 123, 26357b
					</Box>
					<Box sx={{color:'#7ba5ef', bgcolor:'#1b2341'}}>
						1b2341
					</Box>
					<Box sx={{color:'#7ba5ef', bgcolor:'#791520'}}>
						791520
					</Box>
					<Box sx={{color:'#ffffff', bgcolor:'#791520'}}>
						791520
					</Box>
					<Box sx={{color:'#7ba5ef', bgcolor:'#0306d0'}}>
						c3c6d0
					</Box>
					<Box sx={{color:'#050f2d', bgcolor:'#ede580'}}>
						ede580
					</Box>
					<Box sx={{color:'#7ba5ef', bgcolor:'#01030a'}}>
						01030a
					</Box>
					<Box sx={{color:'#7ba5ef', bgcolor:'#050814'}}>
						050814
					</Box>
					<Box sx={{color:'#7ba5ef', bgcolor:'#331d21'}}>
						331d21
					</Box>
					<Box sx={{color:'#7ba5ef', bgcolor:'#140105'}}>
						140105
					</Box>
					<Box sx={{color:'#7ba5ef', bgcolor:'#1f0b0f'}}>
						1f0b0f
					</Box>
					<Box sx={{color:'#7ba5ef', bgcolor:'#bf4ebf'}}>
						bf4ebf
					</Box>
					<Box sx={{color:'#7ba5ef', bgcolor:'#854ebf'}}>
						854ebf
					</Box>
					<Box sx={{color:'#7ba5ef', bgcolor:'#9873A7'}}>
						9873A7
					</Box>
					<Box>
						Table:<br /><br />
					</Box>
					<Box sx={{color:'#7ba5ef', bgcolor:'#0f152b'}}>
						Project: 0f152b
					</Box>
					<Box sx={{color:'#7ba5ef', bgcolor:'#1f2a55'}}>
						Project: 1f2a55
					</Box>
					<Box sx={{color:'#7ba5ef', bgcolor:'#0f152b'}}>
						Project: 0f152b
					</Box>
					<Box sx={{color:'#050f2d', bgcolor:'#eeeeee'}}>
						<WhatshotIcon sx={{ mr: 0.5, color: '#2e805f' }} fontSize="inherit" />
						Task Today dark Odd: 2e805f
					</Box>
					<Box sx={{color:'#050f2d'}}>
						<WhatshotIcon sx={{ mr: 0.5, color: '#2e805f' }} fontSize="inherit" />
						Task Today dark even: 338e6a
					</Box>
					<Box sx={{color:'#050f2d', bgcolor:'#eeeeee'}}>
						<WhatshotIcon sx={{ mr: 0.5, color: '#4ebf92' }} fontSize="inherit" />
						Task Today dark Odd: 2e805f
					</Box>
					<Box sx={{color:'#050f2d'}}>
						<WhatshotIcon sx={{ mr: 0.5, color: '#81d2b1' }} fontSize="inherit" />
						Task Today Odd: 4ebf92
					</Box>
					<Box sx={{color:'#050f2d', bgcolor:'#eeeeee'}}>
						<WhatshotIcon sx={{ mr: 0.5, color: '#81d2b1' }} fontSize="inherit" />
						Task Today Odd: 81d2b1
					</Box>
					<Box sx={{color:'#050f2d'}}>
						<WhatshotIcon sx={{ mr: 0.5, color: '#81d2b1' }} fontSize="inherit" />
						Task Today Odd: 4ebf92
					</Box>
					<Box sx={{color:'#050f2d', bgcolor:'#eeeeee'}}>
						<WhatshotIcon sx={{ mr: 0.5, color: '#81d2b1' }} fontSize="inherit" />
						Task Today Odd: 81d2b1
					</Box>
					<Box sx={{color:'#737373'}}>
						<WhatshotIcon sx={{ mr: 0.5, color: '#4f66c0'}} fontSize="inherit" />
						Task Tomorrow Odd: cdede0
					</Box>
					<Box sx={{color:'#737373', bgcolor:'#eeeeee'}}>
						<WhatshotIcon sx={{ mr: 0.5}} fontSize="inherit" />
						Task Tomorrow Even: f2faf7
					</Box>
					<Box sx={{color:'#737373', bgcolor:'#eeeeee'}}>
						<WhatshotIcon sx={{ mr: 0.5}} fontSize="inherit" />
						Task Tomorrow Even: f2faf7
					</Box>
					<Box sx={{color:'#050f2d'}}>
						<WhatshotIcon sx={{ mr: 0.5, color: '#8191d2'}} fontSize="inherit" />
						Task After Tomorrow Odd: cdede0
					</Box>
					<Box sx={{color:'#737373', bgcolor:'#eeeeee'}}>
						<WhatshotIcon sx={{ mr: 0.5, color: '#8191d2'}} fontSize="inherit" />
						Task After Tomorrow Even: f2faf7
					</Box>
					<Box sx={{color:'#7ba5ef', bgcolor:'#0f152b'}}>
						Project: 0f152b
					</Box>
					<Box sx={{color:'#7ba5ef', bgcolor:'#1f2a55'}}>
						Project: 1f2a55
					</Box>
					</CardContent>
				<CardActions>
				</CardActions>
			</Card>
		</Box>
	);
}
